import type { SelfRoleChoice } from '~/pages/AdminOcctoMaster/tabs/SplitSupplyContract/models/schema'

type Sides = {
  selfRole: SelfRoleChoice
  loadFollowingBusinessMasterId: string
  baseBusinessMasterId: string
}

/**
 * 自社の立場を選んだ時の両側の事業者。 自社の事業者と相手の事業者は入れ替わらず
 * 立場だけが移る (自社の側に自社の事業者が入り、 相手は反対側に移る)。
 *
 * - 自社の事業者: 今の自社の側に入っているもの。 まだ無ければ、 候補が 1 者の時だけ自動で入れる
 *   (複数なら選ばせるので空のまま)。 編集で今の自社の事業者が候補に無くても (候補外)
 *   そのまま保つ。
 * - 相手の事業者: 今の相手の側に入っているもの (立場を選ぶ前は空)。
 *
 * 画面の操作の都合だけの写像で、 立場そのものの導出は backend が両側の事業者から行う。
 */
export function applySelfRole(
  current: Sides,
  role: Exclude<SelfRoleChoice, ''>,
  ownCandidateIds: readonly string[],
): { loadFollowingBusinessMasterId: string; baseBusinessMasterId: string } {
  const currentOwn =
    current.selfRole === 'loadFollowing'
      ? current.loadFollowingBusinessMasterId
      : current.selfRole === 'base'
        ? current.baseBusinessMasterId
        : ''
  const currentPartner =
    current.selfRole === 'loadFollowing'
      ? current.baseBusinessMasterId
      : current.selfRole === 'base'
        ? current.loadFollowingBusinessMasterId
        : ''
  const own =
    currentOwn !== ''
      ? currentOwn
      : ownCandidateIds.length === 1
        ? (ownCandidateIds[0] ?? '')
        : ''
  return role === 'loadFollowing'
    ? {
        loadFollowingBusinessMasterId: own,
        baseBusinessMasterId: currentPartner,
      }
    : {
        loadFollowingBusinessMasterId: currentPartner,
        baseBusinessMasterId: own,
      }
}
